import React, { useEffect, useState } from "react";
import moment from "moment";
import async from "async";
import Request from "../../request";
import { Tag, Button, DatePicker } from "antd";
import FormItem from "../../components/FormItem";
import FilterTable from "../../components/Table";
import _ from "lodash";
import { ConsoleSqlOutlined } from "@ant-design/icons";
import { ConsoleView } from "react-device-detect";

const { RangePicker } = DatePicker;

const CustomDIDHistory = () => {
  const [loading, setLoader] = useState(false);
  const [dataSource, setDataSource] = useState([]);
  const [filters, setFilters] = useState({});
  const [currentPage, setCurrentPage] = useState(1);
  const [selectCustomer, setSelectCustomer] = useState([]);

  const apiFunction = async (filter) => {
    let newFilter = _.cloneDeep(filter);
    // if (newFilter.date) {
    //   newFilter = {
    //     ...newFilter,
    //     startDate: newFilter?.date[0],
    //     endDate: newFilter?.date[1],
    //   };
    //   delete newFilter.date;
    // } else {
    //   delete newFilter.date;
    // }
    setLoader(true);
    let { user, token, success, message, data } =
      await Request.fetchCustomDIDHistory(newFilter);
    setLoader(false);
    if (success && data[0] != null) {
      setDataSource(data);
    } else {
      setDataSource([]);
      // notification.error({
      //     message: message || "Failed"
      // })
    }
  };

  useEffect(() => {
    // setFilters({ date: [moment().subtract("days", 7), moment()] });
    // apiFunction({ date: [moment().subtract("days", 7), moment()] });
    setFilters();
    apiFunction();
    customerFxn();
  }, []);

  const downloadInv = async (filter) => {
    let newFilter = _.cloneDeep(filter);
    // if (newFilter.date) {
    //   newFilter = {
    //     ...newFilter,
    //     startDate: newFilter?.date[0],
    //     endDate: newFilter?.date[1],
    //   };
    //   delete newFilter.date;
    // } else {
    //   delete newFilter.date;
    // }

    setLoader(true);
    const data = await Request.downloadPhoneNumberHistory(newFilter);
    setLoader(false);
  };

  const customerFxn = async () => {
    let { user, token, success, message, data } = await Request.allCustomer();
    if (success) {
      setSelectCustomer(() => data);
    } else {
      setSelectCustomer(() => []);
    }
  };

  const columns = [
    {
      title: "Custom DID",
      dataIndex: "phonenumber",
      key: "phonenumber",
      width: 150,
    },
    {
      title: "Country",
      dataIndex: "Country",
      key: "Country",
      width: 150,
    },
    {
      title: "Customer Name",
      dataIndex: "customer",
      key: "customer",
      width: 250,
    },
    {
      title: "Customer Email",
      dataIndex: "customerEmail",
      key: "customerEmail",
      width: 250,
    },
    {
      title: "Added On",
      dataIndex: "history_date",
      key: "history_date",
      width: 250,

      render: (val, r) => {
        return <Tag>{moment.utc(val).format("DD-MM-YYYY")}</Tag>;
      },
    },
    {
      title: "Status",
      dataIndex: "active",
      key: "active",
      render: (val, r) => {
        return val ? "Active" : "Inactive";
      },
    },
  ];

  return (
    <div>
      <div
        className="flex marginRight jcsb marginTop"
        style={{
          justifyContent: "space-between",
          alignItems: "baseline",
          flexWrap: "wrap",
          gap: "0.5rem",
        }}
      >
        <div className="selectUser" style={{ minWidth: "20rem" }}>
          <FormItem
            label={"Customer"}
            name="Customer"
            initialValues=""
            // rules={requiredRule}
            inputType={"SELECT"}
            options={_.map(selectCustomer, (val) => {
              return {
                label: `${val?.auth?.firstname} ${val?.auth?.lastname} (${val?.auth?.email})`,
                value: val?.id,
              };
            })}
            onChange={(e) => {
              setFilters((prev) => ({ ...prev, customer: e }));
              apiFunction({ ...filters, customer: e });
            }}
          />
        </div>

        {/* <div className="flex marginRight ">
          <div className="marginRight">
            <RangePicker
              onChange={(v) => setFilters((prev) => ({ ...prev, date: v }))}
              value={filters?.date}
            />
          </div>
          <Button
            type="primary"
            className="buttonPrimaryStyle"
            loading={loading}
            onClick={() => {
              apiFunction({ ...filters, customer: customerId });
            }}
          >
            Search
          </Button>
        </div> */}
        <div className="downloadBtn">
          <Button
            type="primary"
            className="buttonPrimaryStyle"
            loading={loading}
            onClick={() => {
              downloadInv(filters);
            }}
          >
            Download
          </Button>
        </div>
      </div>
      <div className="marginTop">
        <FilterTable
          bordered
          dataSource={dataSource}
          columns={columns}
          loading={loading}
          scroll={{ x: "auto" }}
          pagination={{ pageSize: 25 }}
        />
      </div>
    </div>
  );
};

export default CustomDIDHistory;
